export default "__VITE_ASSET__BXd2Dg_X__"